import { ADD_CATEGORY } from '../../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_CATEGORY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_CATEGORY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_CATEGORY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
